import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F90H {
  f90h_01: string;        // 日期 (YYYY-MM-DD, PK)
  f90h_11: string;        // 日期名稱
  f90h_12: number;        // 假日別 (1-6)
  f90h_13: string;        // 輪休組別
  f90h_14: string;        // 備註
  f90h_15: string;        // 摘要
  f90h_21: string;        // 上班時間
  f90h_22: string;        // 下班時間
  f90h_23: string;        // 午休開始
  f90h_24: string;        // 午休結束
  f90h_91: string;        // 建立人員
  f90h_92: string | null; // 建立日期
  f90h_93: string;        // 修改人員
}

export interface CreateRequest {
  f90h_01: string;  // 日期 (YYYY-MM-DD)
  f90h_11: string;  // 日期名稱
  f90h_12: number;  // 假日別
  f90h_13: string;  // 輪休組別
  f90h_14: string;  // 備註
  f90h_15: string;  // 摘要
  f90h_21: string;  // 上班時間
  f90h_22: string;  // 下班時間
  f90h_23: string;  // 午休開始
  f90h_24: string;  // 午休結束
}

export interface UpdateRequest {
  f90h_11: string;  // 日期名稱
  f90h_12: number;  // 假日別
  f90h_13: string;  // 輪休組別
  f90h_14: string;  // 備註
  f90h_15: string;  // 摘要
  f90h_21: string;  // 上班時間
  f90h_22: string;  // 下班時間
  f90h_23: string;  // 午休開始
  f90h_24: string;  // 午休結束
}

export interface ListResponse {
  data: F90H[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// Holiday type mapping
// ============================================================

export const HOLIDAY_TYPES: Record<number, string> = {
  1: '國定假日',
  2: '輪休',
  3: '特別假',
  4: '非正常班',
  5: '全天班',
  6: '半天班',
};

// ============================================================
// API methods
// ============================================================

export const holidayApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/holiday', { params });
    return res.data;
  },

  async get(date: string): Promise<F90H> {
    const res = await apiClient.get(`/api/holiday/${encodeURIComponent(date)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F90H> {
    const res = await apiClient.post('/api/holiday', data);
    return res.data;
  },

  async update(date: string, data: UpdateRequest): Promise<F90H> {
    const res = await apiClient.put(`/api/holiday/${encodeURIComponent(date)}`, data);
    return res.data;
  },

  async delete(date: string): Promise<void> {
    await apiClient.delete(`/api/holiday/${encodeURIComponent(date)}`);
  },
};
